import baseUrl from './baseUrl';

export default (baseUrl === 'https://api.giztix.com') ? 'AIzaSyD2g6CXdO0BQE63OmxAdYAzAkTCx0a42UM' : 'AIzaSyDKhga75-q91tFAGkDJ9ojPsDKzGZpYx4E';